// Textos de Modelos (guía 8.3). Finales.

export const modelosPage = {
  nano: {
    body: "Nuestro primer modelo público. Un modelo base: entiende y escribe español, todavía no está ajustado para conversar.",
    data: ["105,86 M parámetros", "891 M tokens", "contexto 1.024", "Apache 2.0"],
    sheet: { label: "Ficha técnica", href: "/modelos/nano" },
    download: { label: "Descargar en Hugging Face", href: "https://huggingface.co/Manuel12435/YvyrAI-100m-Nano" },
  },
  // 🔵 Confirmar con Juan Manuel las cifras del 150M (5.000 M de tokens y 130 M de
  //    contenido paraguayo) antes de publicar. Guía 1 y 18.
  m150: {
    body: "El siguiente paso: más de 5.000 millones de tokens de español y unos 130 millones de contenido paraguayo. Muy por encima de la cantidad de datos que suele usarse para un modelo de este tamaño.",
  },
  b1: {
    body: "La arquitectura completa a mayor escala. El diseño y el código ya existen.",
  },
  fine: "Publicamos un modelo cuando está entrenado y medido, no antes.",
} as const;
